import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardImg,
  CardTitle,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap"
// import  Util  from "./Common/Util"
import Util from 'pages/Dashboard/Common/Util';

import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';
import Pagination from "pages/Custom/Pagination";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// import images
import defaultImg from "../../assets/images/default.png"

import { useSelector } from 'react-redux';

import { getBuyProductList } from 'crud/auth.crud';
import Loading from 'pages/Custom/Loading';

const selectedClass = 'secondary-bg white-text border-none'
const unselectedClass = 'button-border secondary-text white-bg'

const typeArr = [
  {text: '전체', value: '', color: 'white'},
  {text: '퇴비', value: 'compost', color: '#023047'},
  {text: '사료', value: 'feed', color: '#2EB09F'},
  {text: '폐유', value: 'wasteoil', color: '#126782'},
]

const stateArr = [
  {state: 'U', color: '#2EB09F', text: '거래중'},
  {state: 'N', color: '#FFFFFF', text: ''},
  {state: 'Y', color: '#A3A3A3', text: '거래완료'},
]

const BuyList = props => {
  const history = useHistory()
  const selector = useSelector(state => state)
  const newDate = new Date()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const page = queryParams.get('page') || 1
  const searchText = queryParams.get('search_text') || ''
  const productType = queryParams.get('product_type') || ''

  const [isListEnd, setIsListEnd] = useState(false)
  const [dataList, setDataList] = useState([])
  const [search, setSearch] = useState('')
  const [exchangeState, setExchangeState] = useState('buy')

  const [onUpload, setOnUpload] = useState(false);
  const [totalDataCount, setTotalDataCount] = useState(0)

  // 상품목록 가져오는 용
  const getDataList = async () => {
    if (onUpload)
      return

    setOnUpload(true)

    let params = {
      page: page,
      search: searchText,
      product_type: productType
    }

    const response = await getBuyProductList(params);
    setTotalDataCount(response.data.count || 0)
    if (response.status === 200) {
      const content = response.data?.results || [];
      setDataList(content)
      if (content.length === 0) {
        setIsListEnd(true)
      }
    }
    setOnUpload(false)
  }

  const setPrice = (price) => {
    return Math.round(price)?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  useEffect(() => {
    getDataList()
  }, [searchText, productType, page])

  const changeSearch = () => {
    queryParams.set("search_text", search);
    const url = `${location.pathname}?${queryParams.toString()}`
    history.push(url)
  }

  const changeType = (value) => {
    queryParams.set("product_type", value);
    const url = `${location.pathname}?${queryParams.toString()}`
    history.push(url)
  }

  const clickList = (item) => {
    // setDetailData({...item});
    const url = {
      pathname: `/buy-detail-screen`,
      state: { ...item }
    }
    history.push(url);
  }

  return (
    <React.Fragment>
    <div className="page-content">
      <MetaTags>
        <title>거래소 상품 관리 | 웨이스트버스</title>
      </MetaTags>
      <Container fluid>
        <Row>
          <Breadcrumbs maintitle="Home" title="" breadcrumbItem="거래소 상품 관리" />

          <Col sm={12}>
            <div className="d-flex align-items-center justify-content-between" style={{ height: 35 }}>
              <div className="float-start btn-group">
                <button
                  type="button"
                  size="sm"
                  className={`border-radius-0 margin-right-4 font-size-11 line-height-1 ${exchangeState == 'sell' ? selectedClass : unselectedClass}`}
                  style={{ width: 100, height: 35 }}
                  onClick={() => {
                    setExchangeState('sell')
                    props.stateChange("sell")
                  }}
                >
                  판매리스트
                </button>
                <button
                  type="button"
                  size="sm"
                  className={`border-radius-0 margin-right-4 font-size-11 line-height-1 ${exchangeState == 'buy' ? selectedClass : unselectedClass}`}
                  style={{ width: 100, height: 35 }}
                  onClick={() => {
                    setExchangeState('buy')
                    props.stateChange("buy")
                  }}
                >
                  구매리스트
                </button>
              </div>
              <div className="position-relative app-search d-none d-lg-block">
                <input
                  style={{width: 360, borderColor: '#A3A3A3', borderRadius: 0,}}
                  className="form-control"
                  placeholder="검색어를 입력해주세요"
                  onChange={(e) => {
                    setSearch(e.target.value)
                  }}
                  onKeyDown={(e) => {
                    if (e.key == 'Enter') {
                      changeSearch()
                    }
                  }}
                />
                <span onClick={() => {
                  changeSearch()
                }} className="fa fa-search" style={{ lineHeight: '38px', cursor: 'pointer' }} />
              </div>
              <div className="waver-pagination-btn-group" >
                <button style={{ width: 100, height: 35 }} type="button" className="border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
                  history.push('/sell-request-write')
                }}>
                  판매등록
                </button>
              </div>
            </div>
          </Col>
          
          <Col sm={12}>
            <div className="d-flex align-items-center margin-top-30 margin-bottom-12">
              <p className='font-size-15 font-weight-bold mb-0 margin-right-10'>상품정렬</p>
              {typeArr.map((item, index) => (
                <button key={item.value + index} style={{ width: 38, height: 24, backgroundColor: item.color }} type="button" className={`border-radius-0 margin-right-4 font-size-11 line-height-1 ${item.color == 'white' ? unselectedClass : selectedClass}`} onClick={() => {
                  changeType(item.value)
                }}>
                  {item.text}
                </button>
              ))}
            </div>
          </Col>

          {/* <Col sm={12}>
            <div className="d-flex align-items-center justify-content-between">
              <div className="position-relative app-search d-none d-lg-block">
                <input
                  className="form-control"
                  placeholder="검색어를 입력해주세요..."
                  onChange={(e) => {
                    setSearch(e.target.value.length == 0 ? '' : e.target.value)
                  }}
                  onKeyPress={(e) => {
                    if (e.key == 'Enter') {
                      setSearchText(search)
                    }
                  }}
                />
                <span onClick={() => {
                  setSearchText(search)
                }} className="fa fa-search" style={{ lineHeight: '36px', cursor: 'pointer' }} />
              </div>
              <div className="waver-pagination-btn-group" >
                <button className="waves-effect submit-btn btn btn-secondary margin-left-6 font-size-16"
                  onClick={() => {
                    history.push('/sell-request-write')
                  }} >판매등록</button>
              </div>
            </div>
          </Col> */}
        </Row>

        <Row>
          {dataList.length > 0 && dataList.map((item, index) => {
            const typeItem = typeArr.find(v => v.value === item.product_type)
            const stateItem = stateArr.find(v => v.state === item.state)
            return (
              <Col className='pointer' xl={3} md={6} key={item.id + '_' + index} onClick={() => { clickList(item) }}>
                <Card className="directory-card" style={{border: '1px solid #D9D9D9', borderRadius: 0}}>
                  <CardBody>
                    <div className="d-flex">
                      <img
                        src={"http://wasteverse.ropiklabs.com" + item.trade_file?.[0]?.path}
                        alt="사진"
                        className="img-fluid avatar-lg"
                        style={{ borderRadius: '4px' }}
                        onError={(e) => e.target.src = defaultImg}
                      />
                      <div className="flex-1 ms-3 d-flex flex-column justify-content-between">
                        <div>
                          <div className='d-flex justify-content-between align-items-center'>
                            <div style={{ width: 38, height: 24, backgroundColor: typeItem.color, textAlign: 'center'}} type="button" className={`border-radius-0 margin-right-4 font-size-11 line-height-1 ${typeItem.color == 'white' ? unselectedClass : selectedClass}`}>
                              <p className='mb-0' style={{lineHeight: '24px'}}>{typeItem.text}</p>
                            </div>
                            {item.state !== 'N' &&
                            <div style={{ width: 60, height: 24, backgroundColor: stateItem.color, textAlign: 'center'}} type="button" className={`border-radius-0 margin-right-4 font-size-11 line-height-1 white-text border-none`}>
                              <p className='mb-0' style={{lineHeight: '24px'}}>{stateItem.text}</p>
                            </div>
                            }
                          </div>
                          <h5 className="font-size-13 mt-3 mb-1 text-black">
                            {item.subject ?? ''}
                          </h5>
                          <p className='font-size-12 text-gray'>재고 : {Util.setPrice(item.qty)}kg</p>
                        </div>
                        <div className='d-flex align-items-center'>
                          {/* <div className={`waves-effect waves-light ${item.state === 'U' ? 'bg-primary' : item.state === 'N' ? 'bg-white' : 'bg-gray'} exchange-tag text-white font-size-12 margin-right-8`}>{item.state === 'U' ? '거래중' : item.state === 'N' ? '' : '거래완료'}</div> */}
                          <p className="mb-0 text-end font-size-12">단가 : kg당 <span className='font-size-15 font-weight-bold'>{Util.setPrice(item.price_per_kg)}</span>원</p>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            )
          })
          }
          {dataList.length === 0 &&
            <Col xl={4} md={6}>
              <Card className="directory-card">
                <CardBody>
                  <div className="d-flex">
                    <img
                      src={defaultImg}
                      alt="사진"
                      className="img-fluid avatar-lg"
                      style={{ borderRadius: '4px' }}
                    />
                    <div className="flex-1 ms-4 d-flex flex-column justify-content-between">
                      <div>
                        <h5 className="font-size-18 mt-0 mb-1 text-black">
                          {'상품이 존재하지 않습니다.'}
                        </h5>
                        <p className='font-size-14 text-gray pt-1'>재고: - kg</p>
                      </div>
                      <div className='d-flex align-items-center justify-content-end'>
                        <p className="mb-0 text-end font-size-14">kg당 - 원</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          }
        </Row>
        <Pagination totalDataCount={totalDataCount} isLoading={onUpload} />
      </Container>
    </div>
    {onUpload && <Loading />}

    </React.Fragment>
  )
}

export default BuyList
